
import { Checkbox, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material"
import { LayoutTabla } from "../../layout"
import { InputSeparadorDecimal } from "../inputs/InputSeparadorDecimal"
import { separadorMillares } from "../../../helpers"






export const TablaOCDetalles = ({ selected, handleClick, handleSelectAllClick, 
                                    handlePrecioChange, isSelected, itemsFinal }) => {


    const totalFactura = itemsFinal.reduce((acc, item) => acc + Number(item.total), 0);


    // const { totalItemsPago } = useItemspagoStore();
    // const debounceRef = useRef(null);
    // const [opciones, setOpciones] = useState([]);
    // const [cargando, setCargando] = useState(false);
    // const buscarInfo = (texto) => {
    //     if(debounceRef.current){ clearTimeout(debounceRef.current); }
    //     debounceRef.current = setTimeout(async () => {
    //         const query = texto.trim();
    //         if (query.length === 0) return;
    //         setCargando(true);
    //         const respuesta = await startProductosTodos(texto);
    //         setOpciones(respuesta)
    //         setCargando(false);
    //         console.log('cambiar producto')
    //     }, 700);
    // };

    // const handleChange = async (event, nuevoProducto) => {
    //     // setValue(nuevoProducto);

    //     // if (nuevoProducto) {
    //     // try {
    //     //     console.log('holis holis')
    //     //     // // Actualiza en DB (PUT o PATCH según tu API)
    //     //     // await axios.put(`/api/items/${productoActual._id}`, {
    //     //     // producto: nuevoProducto._id,
    //     //     // });

    //     //     // // Avisar al padre para refrescar si es necesario
    //     //     // onProductoActualizado(nuevoProducto);
    //     // } catch (error) {
    //     //     console.error("Error actualizando producto:", error);
    //     // }
    //     // }
    //     console.log('Holis')
    // };
{/* <TableCell>
    <Autocomplete
        size="small"
        fullWidth
        options={ opciones || [{ _id: d._id, nombre: d.producto }] }
        loading={cargando}
        // 👇 valor por defecto (el producto actual)
        value={{ _id: d._id, nombre: d.producto }}
        getOptionLabel={(option) => option.nombre || ""}
        onChange={(e, nuevo) => handleChange(nuevo, d._id)}
        onInputChange={(e, value) => buscarInfo(value)}
        // 👇 comparación por _id, así no da el error
        isOptionEqualToValue={(option, value) =>
            option._id === value._id
        }
        renderInput={(params) => (
            <TextField
            {...params}
            label="Producto"
            placeholder="Buscar producto..."
            />
        )}
        />
</TableCell> */}


    const actualizarProducto = () => {
        console.log('Holis HOlis')
    }



    return (

        <LayoutTabla mb={3}>
            <TableHead>
                <TableRow>
                    <TableCell sx={{ width: "5%", p: 1 }}>
                        <Checkbox
                            color="secondary"
                            indeterminate={selected.length > 0 && selected.length < itemsFinal.length}
                            checked={
                            itemsFinal.length > 0 && selected.length === itemsFinal.length
                            }
                            onChange={() => handleSelectAllClick(itemsFinal)}
                        />
                    </TableCell>
                    <TableCell sx={{ width: "30%" }}>Producto</TableCell>
                    <TableCell sx={{ width: "15%" }}>Cantidad</TableCell>
                    <TableCell sx={{ width: "20%" }}>Detalles</TableCell>
                    <TableCell sx={{ width: "15%" }}>Precio Uni.</TableCell>
                    <TableCell sx={{ width: "20%" }}>Total</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {itemsFinal.map((item) => (
                <TableRow key={item._id}>
                    <TableCell sx={{ p: 1 }}>
                        <Checkbox color="primary" checked={ isSelected(item._id) } onChange={() => handleClick(item)} />
                    </TableCell>
                    <TableCell>{ item.producto }</TableCell>
                    <TableCell>{item.totalCantidad}</TableCell>
                    <TableCell>
                        {item.detalle.map((det, j) => (
                        <div key={j}>
                            <strong>{det.granja.nombre}</strong> — <strong>Cantidad:</strong> {det.cantidad}
                        </div>
                        ))}
                    </TableCell>
                    <TableCell>
                        <InputSeparadorDecimal
                            size="small"
                            label='Precio Con Iva'
                            placeholder='Precio Con Iva'
                            fullWidth
                            name='precioSin'
                            value={item.precio || ""}
                            onChange={(e) => handlePrecioChange(item._id, e.target.value)}
                        />
                    </TableCell>
                    <TableCell>{`$${separadorMillares(item.totalCantidad * item.precio)}`}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            
            {(totalFactura > 0) &&
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={4} align="right">
                        <strong>Total:</strong>
                    </TableCell>
                    <TableCell colSpan={2}>
                        <strong>{`$${separadorMillares(totalFactura)}`}</strong>
                    </TableCell>
                </TableRow>
            </TableFooter>
            }
        </LayoutTabla>

    )
}

{/* {(data.length > 0) */}
// <FormBuscaryEditarProductoOC
//     key={item._id}
//     item={item}
//     isSelected={isSelected}
//     handleClick={handleClick}
//     handlePrecioChange={handlePrecioChange}
//     actualizarProducto={actualizarProducto}
// />